"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
exports.__esModule = true;
var jsx_runtime_1 = require("react/jsx-runtime");
var ui_components_1 = require("@codametrix/ui-components");
//import ReactMarkdown from 'react-markdown';
var ui_common_1 = require("@codametrix/ui-common");
var AcceptableEula = function (props) {
    var eula = props.eula, context = props.context, optionalEulaAcceptancePayload = props.optionalEulaAcceptancePayload, onEulaAccept = props.onEulaAccept, onEulaCancel = props.onEulaCancel;
    var acceptEulaClick = function () {
        var datedEula = __assign(__assign({}, eula), { acceptedDate: ui_common_1.cmxDateTime.format(new Date(), ui_common_1.cmxDateTime.FORMATS.DATE_TIME_EULA) });
        onEulaAccept({
            eula: datedEula,
            context: context,
            optional: optionalEulaAcceptancePayload
        });
    };
    var footerChildren = ((0, jsx_runtime_1.jsxs)("div", __assign({ className: 'columns' }, { children: [(0, jsx_runtime_1.jsxs)(ui_components_1.RoundedButton, __assign({ className: 'btn btn-primary qa-submit-button column', onClick: function () {
                    acceptEulaClick();
                } }, { children: [' ', "Accept"] })), (0, jsx_runtime_1.jsx)("div", { className: 'column col-1' }), (0, jsx_runtime_1.jsxs)(ui_components_1.RoundedButton, __assign({ className: 'btn btn-secondary qa-cancel-button column', onClick: function () {
                    onEulaCancel(true);
                } }, { children: [' ', "Cancel"] }))] })));
    return ((0, jsx_runtime_1.jsx)("div", __assign({ className: 'qa-acceptable-eula acceptable-eula' }, { children: (0, jsx_runtime_1.jsx)(ui_components_1.Modal, __assign({ footerChildren: footerChildren, closable: false, title: 'CodaMetrix End User License Agreement' }, { children: (0, jsx_runtime_1.jsx)("div", { children: eula.text }) })) })));
};
AcceptableEula.displayName = 'AcceptableEula';
exports["default"] = AcceptableEula;
//# sourceMappingURL=acceptable-eula.js.map